import styled, { css } from 'styled-components';
import { Select as AntSelect } from 'antd';
import { Dimension } from 'interfaces/interfaces';
import { normalizeProp } from '@app/utils/utils';
import { FONT_WEIGHT, BORDER_RADIUS, FONT_SIZE } from '@app/styles/themes/constants';

export interface InternalSelectProps {
  $width?: Dimension;
  $shadow?: boolean;
  $multiLineOptions?: boolean;
}

export const Select = styled(AntSelect)<InternalSelectProps>`
  width: ${(props) => props.$width && normalizeProp(props.$width)};

  font-weight: ${FONT_WEIGHT.medium};

  &.ant-select .ant-select-selector {
    background-color: var(--highlighting-color) !important;
  }

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input,
  &.ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder,
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    // height: 35px;
    border: 0;
  }

  &&& .ant-select-dropdown {
    box-shadow: 0 0 10px 0 rgba (0, 0, 0, 0.1);
    right: 0 !important;
  }

  .ant-select-dropdown,
  .ant-mentions-dropdown-menu-item-active,
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background: var(--select-backgroung-color) !important;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background: var(--highlighting-color) !important;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: var(--select-backgroung-color) !important;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    // line-height: 35px;
  }

  & .ant-select-selector .ant-select-selection-item {
    background: transparent;
    border: 0px;
  }

  box-shadow: ${(props) => props.$shadow && 'var(--box-shadow)'};

  &.ant-select-borderless {
    background: var(--select-background-color);

    border-radius: ${BORDER_RADIUS};
  }

  .ant-select-selection-placeholder {
    font-size: ${FONT_SIZE.xs};

    color: var(--text-main-color);
  }

  .ant-select-arrow {
    color: var(--text-main-color);
  }

  &.ant-select-multiple.ant-select-sm .ant-select-selection-item {
    height: 0.875rem;
    line-height: ${FONT_SIZE.xs};
    font-size: ${FONT_SIZE.xs};
    margin-top: 0.1875rem;
    margin-bottom: 0.1875rem;
  }

  &.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: var(--disabled-color);
  }

  .ant-select-clear {
    color: var(--text-main-color);
    background: transparent;
  }
  .ant-select-selection-item-remove {
    color: var(--icon-color);
    &:hover {
      color: var(--icon-hover-color);
    }
  }
  .ant-select-item-option-disabled {
    color: var(--disabled-color);
  }

  /* Enable multi-line wrapping for dropdown options */
  ${(props) =>
    props.$multiLineOptions
      ? css`
          .ant-select-item-option-content {
            white-space: normal !important;
            word-wrap: break-word !important;
            word-break: break-word !important;
            line-height: 1.4 !important;
          }

          .ant-select-item {
            height: auto !important;
            min-height: 32px !important;
            padding: 8px 12px !important;
          }
        `
      : ''}

  ${(props) =>
    props.showSearch === false
      ? css`
          .ant-select-selection-overflow > .ant-select-selection-overflow-item-suffix {
            height: 0;
          }

          &&& .ant-select-selection-overflow {
            flex-wrap: nowrap;
          }
        `
      : ''}
`;
